<p-columnFilter
*ngIf="false"
  [type]="type"
  [field]="field"
  [matchMode]="$any(matchMode)"
  display="menu"
  [showOperator]="false"
  [showAddButton]="false"
  [pTooltip]="'button:Filter' | i18next"
  tooltipPosition="top"
  [hideOnClear]="true"
  [showApplyButton]="showApplyButton"
  [showClearButton]="showClearButton"
  [matchModeOptions]="matchModeOptions"
>
  <ng-template
    *ngIf="useFilterTemplate"
    pTemplate="filter"
    let-value
    let-filter="filterCallback"
  >
    <ng-container
      [ngTemplateOutlet]="filterTemplateRef"
      [ngTemplateOutletContext]="{ $implicit: value, filterCallback: filter }"
    >
    </ng-container>
  </ng-template>
</p-columnFilter>
